import { addDoc, collection, doc } from "firebase/firestore";
import { db } from "../../firebase";
import { getLocalStorageItem } from "../localStorage/getLocalStorage";
import HelperForMetaData from "../../helpers/HelperForMetaData";

const CreateAgentForInvitation = async (e) => {
  try {
    let agentsGroupRef = await doc(db, "clients", getLocalStorageItem("bid"));
    agentsGroupRef = collection(agentsGroupRef, "agents");
    const data = {
      ...e,
      status: "invite",
      bid: getLocalStorageItem("bid"),
      ...HelperForMetaData(),
    };
    await addDoc(agentsGroupRef, data);
    return true;
  } catch (error) {
    console.log(error);
    return false;
  }
};

export default CreateAgentForInvitation;
